import { v4 as uuid } from 'uuid';
import { SIMPLE_CALLOUT_NODE_NAME } from '../../editor/extensions/simple-callout';
import { CalloutColor, ContentBlockType, SimpleCalloutBlock } from '../../model';
import { BlockToTiptapConverter, convertBlocksToTiptapNodes, ConverterContext } from '../blocks-to-tiptap.converter';
import { convertTiptapNodesToBlocks, TiptapToBlockConverter } from '../tiptap-to-blocks.converter';

export const convertSimpleCalloutBlockToTiptap = ((block, context?: ConverterContext) => {
  return {
    type: SIMPLE_CALLOUT_NODE_NAME,
    attrs: {
      id: block.id,
      title: block.title,
      color: block.color,
      ...(block.icon && { icon: block.icon }),
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
    },
    content: convertBlocksToTiptapNodes(block.content, context),
  };
}) satisfies BlockToTiptapConverter<SimpleCalloutBlock>;

export const convertTiptapToSimpleCalloutBlock = ((json, context?) => {
  const attrs = json.attrs ?? {};
  const content = json.content ?? [];

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.SimpleCallout,
    title: (attrs['title'] as string) ?? '',
    color: (attrs['color'] as CalloutColor) ?? CalloutColor.Sky,
    ...(attrs['icon'] && { icon: attrs['icon'] as string }),
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
    content: content.length ? convertTiptapNodesToBlocks(content, context) : [],
  };
}) satisfies TiptapToBlockConverter;
